import { render } from "./KitsManagerView.vue?vue&type=template&id=67630c9b"
import script from "./KitsManagerView.vue?vue&type=script&lang=js"
export * from "./KitsManagerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__